import React from 'react';

const customerServiceNumber = '800.824.8742';

export const ERROR_TYPES = {
  LOGIN_PAGE: {
    EMPTY_INPUT: 'Email Address or Username, and Password are required.',
    USER_NOT_FOUND: `
      We couldn't find an account matching the email address or username, and password you entered.
      Please check your email address or username, and password and try again.
    `,
    TRY_AGAIN: `
      Something went wrong when trying to sign you in.
      Please try again later.
    `,
    EXCESSIVE_ATTEMPTS: `
      Account is locked due to multiple invalid sign in attempts.
      Please try again later or reset your password.
    `,
  },
  UPDATE_EMAIL_PAGE: {
    EMPTY_INPUT: 'Email Address is required.',
    EMAIL_IN_USE:
      'The entered email address is invalid or already in use. Please try a different one.',
    TRY_AGAIN: `
      Something went wrong when trying to update your email.
      Please try again later.
    `,
    TRANSFER_SUCCESS: 'Instructions have been sent to your email address.',
    TRANSFER_FAILURE: `
      Something went wrong with requesting transfer information.
      Please call customer servicie at ${customerServiceNumber} for assistance.
    `,
    TRANSFER_NETWORK_FAILURE: (apiDomain: string): JSX.Element => (
      <span>
        Network failure encountered requesting transfer information. Please ensure you are connected
        to the internet and the domain
        <a href={`https://${apiDomain}/ping`}> iam-api.kaplanlearn.com </a>
        is not being blocked by your corporate network.
      </span>
    ),
  },
  CHANGE_PASSWORD_PAGE: {
    EMPTY_INPUT: 'Your current password is required.',
    INCORRECT_PASSWORD:
      'The current password you provided did not match our records. Please check it and try again.',
  },
  FORGOT_PASSWORD_PAGE: {
    EMPTY_INPUT: 'Email Address or Username is required.',
    CHANGE_PASSWORD_ERROR: `
      Something went wrong when sending the password message.
      Please try again later.
    `,
    CALL_IN_TO_FIX_ACCOUNT: `
      There appears to be a problem with your account.
      Please call customer service at ${customerServiceNumber} for assistance.
    `,
    EMAILED_INSTRUCTIONS: `
      Instructions for resetting your password have been sent to your email.
    `,
  },
  RESET_PASSWORD_PAGE: {
    CODE_INVALID: 'Code is required',
  },
  REGISTER_PAGE: {
    USERNAME_REQUIRED: 'Username is required.',
    PASSWORD_AND_CONFIRM_REQUIRED: 'Password, and Confirm Password are required.',
    PASSOWRDS_DONT_MATCH: 'Passwords do not match.',
    TRY_AGAIN: `
      Something went wrong when finishing your account setup.
      Please try again later.
    `,
    CANNOT_COMPLETE_SIGN_UP:
      'We were unable to process your request. Please check that you followed the full link in your email.',
  },
  FIELD_MUST_CONFORM: (conform: string, field: string): string => `${field} must conform to the following: ${conform}`,

  NEW_PASSWORD_REQUIRED: 'New Password, and Confirm New Password are required.',
  PASSWORD_DOES_NOT_MATCH: 'Passwords do not match.',
  CODE_VERIFICATION_EXPIRED: 'Verification code has expired. A new one has been sent.',
  PASSWORD_NOT_LONG_ENOUGH: 'Password does not conform to policy: Password not long enough.',
  TRY_AGAIN_RESET_PASSWORD: `
    Something went wrong when resetting you password.
    Please try again later.
  `,

  NOT_AUTHORIZED: 'NotAuthorizedException',
  USER_NOT_FOUND: 'UserNotFoundException',
  INVALID_PARAMETER_EXCEPTION: 'InvalidParameterException',
  CODE_MISMATCH_EXCEPTION: 'CodeMismatchException',
  INVALID_PASSWORD_EXCEPTION: 'InvalidPasswordException',
  LIMIT_EXCEEDED_EXCEPTION: 'LimitExceededException',
  EXPIRED_CODE_EXCEPTION: 'ExpiredCodeException',
  USER_LAMBDA_VALIDATION_EXCEPTION: 'UserLambdaValidationException',
  INVALID_EMAIL_FORMAT: 'Invalid email address format.',
  MISSING_EMAIL: 'No email provided but email_verified was true',
  NETWORK_FAILURE: (awsRegion: string, apiDomain: string): JSX.Element => (
    <span>
      Network failure encountered checking connectivity to login. Please ensure you are connected to
      the internet and you don&apos;t have a firewall or web filter blocking the following domains:
      <ul>
        <li>
          <a href={`https://cognito-idp.${awsRegion}.amazonaws.com/ping`}>
            cognito-idp.us-east-2.amazonaws.com
          </a>
        </li>
        <li>
          <a href={`https://${apiDomain}/ping`}>iam-api.kaplanlearn.com</a>
        </li>
      </ul>
    </span>
  ),
};
export const ERROR_MESSAGE = 'ERROR_MESSAGE';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';
export const LOG_ERROR = 'LOG_ERROR';
export const JWT_SESSION = 'JWT_SESSION';
export const LISTENING_FOR_JWT_SESSION = 'LISTENING_FOR_JWT_SESSION';
export const PASSWORD_CHANGED = 'PASSWORD_CHANGED';
export const RESIZE = 'RESIZE';
export const REQUEST_CREATE_PERSON = 'REQUEST_CREATE_PERSON';
export const RESPONSE_CREATE_PERSON = 'RESPONSE_CREATE_PERSON';
export const SET_THEME = 'SET_THEME';
